import usePDFTheme from '@/utils/hooks/usePDFTheme';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useMemo } from 'react';

export const disclaimerParagraphs: string[] = [
    'Cryptoassets are high-risk investments. The value of cryptoassets can go down as well as up, and you could lose all the money you invest. Cryptoasset activities are not regulated by the Financial Conduct Authority and are not protected by the Financial Services Compensation Scheme or the Financial Ombudsman Service. Please ensure you understand the risks before trading.',
    'Digital asset services are provided by GC Exchange A/S, a company incorporated in Denmark (CVR 43088777) with address at Amager Strandvej 390, 2770, Kastrup. GC Exchange A/S is authorised and regulated by the Danish Financial Supervisory Authority (Finanstilsynet) as a Crypto-Asset Service Provider under the EU Markets in Crypto-Assets Regulation (MiCA 10901) and as a Currency Exchange (FTID 45020)'
];

const PortfolioStatementDisclaimer = () => {
    const [lead, ...rest] = disclaimerParagraphs;

    const pdfTheme = usePDFTheme();

    const { base, palette, fontFamily } = pdfTheme;

    const styles = useMemo(() => {
        return StyleSheet.create({
            card: {
                backgroundColor: palette.surface,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: palette.border,
                borderLeftWidth: 3,
                borderLeftColor: palette.primary,
                paddingVertical: 20,
                paddingHorizontal: 22,
                marginTop: 12
            },
            lead: {
                fontSize: 8.5,
                lineHeight: 1.6,
                color: palette.ink,
                fontFamily,
                fontWeight: 500
            },
            paragraph: {
                fontSize: 8,
                lineHeight: 1.65,
                marginTop: 12,
                color: palette.neutral,
                fontFamily,
                fontWeight: 400
            }
        });
    }, [fontFamily, palette]);

    return (
        <View>
            <Text style={base.eyebrow}>DISCLAIMER</Text>
            <Text style={base.sectionTitle}>Important information</Text>
            <View style={styles.card}>
                <Text style={styles.lead}>{lead}</Text>
                {rest.map((paragraph) => (
                    <Text key={paragraph.slice(0, 24)} style={styles.paragraph}>
                        {paragraph}
                    </Text>
                ))}
            </View>
        </View>
    );
};

export default PortfolioStatementDisclaimer;
